import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { ChevronDown } from 'lucide-react';

const SiteSelector: React.FC = () => {
  const { userInfo, selectedSite, setSelectedSite } = useAuth();
  const [isOpen, setIsOpen] = React.useState(false);

  if (!userInfo || userInfo.sites.length === 0) {
    return null;
  }

  if (userInfo.sites.length === 1) {
    return (
      <div className="px-3 py-2 bg-gray-100 rounded-lg text-sm font-medium text-gray-700">
        {userInfo.sites[0]}
      </div>
    );
  }

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-lg text-sm font-medium text-gray-700 transition-colors duration-200"
      >
        <span>{selectedSite || 'Select Site'}</span>
        <ChevronDown className={`w-4 h-4 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <>
          <div
            className="fixed inset-0 z-10"
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute top-full mt-2 right-0 bg-white border border-gray-200 rounded-lg shadow-lg z-20 min-w-[200px]">
            <div className="py-1">
              {userInfo.sites.map((site) => (
                <button
                  key={site}
                  onClick={() => {
                    setSelectedSite(site);
                    setIsOpen(false);
                  }}
                  className={`w-full text-left px-4 py-2 text-sm hover:bg-gray-100 transition-colors duration-200 ${
                    selectedSite === site ? 'bg-green-50 text-green-700 font-medium' : 'text-gray-700'
                  }`}
                >
                  {site}
                </button>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SiteSelector;

